import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import {
  Grid,
  Row,
} from 'react-bootstrap';

import TimesheetNavEnhanced from './TimesheetNavEnhanced';
import TimesheetOverviewEnhanced from './TimesheetOverviewEnhanced';
import TimesheetDetailsEnhanced from './TimesheetDetailsEnhanced';

const propTypes = exact({
  selectedUserId: PropTypes.number,
});

const TimesheetNavigationPanel = (props) => {
  const { selectedUserId } = props;

  return (
    <div>
      { selectedUserId && (
        <Grid fluid>
          <Row>
            <TimesheetNavEnhanced />
          </Row>
          <Row>
            <TimesheetOverviewEnhanced />
          </Row>
          <Row>
            <TimesheetDetailsEnhanced />
          </Row>
        </Grid>
      )}
      { !selectedUserId && <Row>Please Select an Employee</Row> }
    </div>
  );
};

TimesheetNavigationPanel.propTypes = propTypes;

export default TimesheetNavigationPanel;
